import companyHomeActions from '../actionTypes/companyHomeActions';

const initialState = {
  isLoading: true,
  data: {
    attributes: {},
  },
  isSubmitting: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case companyHomeActions.getCompanyHomeDetails:
      return { ...state, isLoading: true };
    case companyHomeActions.getCompanyHomeDetailsSuccess:
      return { ...state, ...action.payload, isLoading: false };
    case companyHomeActions.getCompanyHomeDetailsFailed:
      return { ...state, isLoading: false };
    case companyHomeActions.updateCompany:
    case companyHomeActions.updateCompanyFailed:
      return {
        ...state,
        ...action.payload,
        isSubmitting: false,
        isLoading: false,
      };
    case companyHomeActions.updateCompanySuccess:
      return {
        ...state,
        ...action.payload,
        isLoading: false,
        isSubmitting: false,
        errors: null,
      };
    default:
      return state;
  }
};
